import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeft, Clock, Play, BookOpen, GraduationCap } from 'lucide-react';

export default function LearnPage() {
  const { id } = useParams();

  return (
    <div style={{ paddingTop: 68, minHeight: '100vh' }}>
      {/* Header */}
      <div style={{
        background: 'var(--ac-navy)', borderBottom: '1px solid var(--ac-border)', padding: '1.5rem 0',
      }}>
        <div className="container" style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <Link to="/dashboard" style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 13, color: 'var(--ac-muted)', textDecoration: 'none' }}
            onMouseEnter={e => e.currentTarget.style.color = 'var(--ac-cyan)'}
            onMouseLeave={e => e.currentTarget.style.color = 'var(--ac-muted)'}
          >
            <ArrowLeft size={14} /> Back to Dashboard
          </Link>
        </div>
      </div>

      {/* Coming Soon State */}
      <div style={{
        minHeight: 'calc(100vh - 130px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: `radial-gradient(ellipse at 50% 40%, rgba(168,85,247,0.07) 0%, transparent 55%), var(--ac-dark)`,
      }}>
        <div style={{ textAlign: 'center', maxWidth: 520, padding: '2rem' }}>
          <div style={{
            width: 100, height: 100, borderRadius: '50%', margin: '0 auto 2rem',
            background: 'rgba(168,85,247,0.1)', border: '2px solid rgba(168,85,247,0.25)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <Play size={44} color="var(--ac-purple)" />
          </div>
          <div className="badge badge-purple" style={{ marginBottom: '1.2rem' }}><GraduationCap size={14} /> Altera Scholar</div>
          <h1 style={{ fontSize: 32, fontWeight: 800, color: 'var(--ac-white)', marginBottom: '1rem', lineHeight: 1.2 }}>
            Course Content<br /><span className="grad-text-edu">Launching July 2026</span>
          </h1>
          <p style={{ fontSize: 15, color: 'var(--ac-muted)', lineHeight: 1.8, marginBottom: '2rem' }}>
            Our video lessons are being produced by the AlteraCode team. 
            You're enrolled and will get full access the moment the course goes live.
          </p>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '2.5rem' }}>
            {[
              { Icon: BookOpen, label: 'Self-paced learning' },
              { Icon: Clock, label: 'Launching July 2026' },
              { Icon: Play, label: 'HD Video lessons' },
            ].map(({ Icon, label }, i) => (
              <div key={i} style={{
                display: 'flex', alignItems: 'center', gap: 8,
                background: 'rgba(168,85,247,0.08)', border: '1px solid rgba(168,85,247,0.2)',
                borderRadius: 20, padding: '7px 16px', fontSize: 13, color: 'var(--ac-purple)',
              }}>
                <Icon size={14} /> {label}
              </div>
            ))}
          </div>
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/dashboard" className="btn btn-outline-purple">My Dashboard</Link>
            <Link to="/educenter" className="btn btn-edu">Browse More Courses</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
